import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { DatasourceList } from "@/components/portal/apps/reporting/datasources";
import { usePortalData } from "@/components/portal/PortalDataProvider";

export const Route = createFileRoute(
  "/portal/apps/reporting/datasources/",
)({
  component: DatasourcesPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): { groupAccess?: string; groupAccessName?: string } => ({
    groupAccess:
      typeof search.groupAccess === "string" && search.groupAccess.length > 0
        ? search.groupAccess
        : undefined,
    groupAccessName:
      typeof search.groupAccessName === "string" && search.groupAccessName.length > 0
        ? search.groupAccessName
        : undefined,
  }),
});

function DatasourcesPage() {
  const { selectedOrganisation } = usePortalData();
  const organisationId = selectedOrganisation?.organisationId ?? "";
  const { groupAccess, groupAccessName } = Route.useSearch();

  return (
    <div className="space-y-6">
      <Link
        to="/portal/apps/reporting"
        className="flex items-center gap-2 text-sm text-primary transition hover:text-primary"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Reporting
      </Link>
      <div>
        <h1 className="text-2xl font-semibold">Datasources</h1>
        <p className="text-sm text-muted-foreground">
          Manage approved data sources that users can build reports from.
        </p>
      </div>
      <DatasourceList
        organisationId={organisationId}
        initialGroupAccessId={groupAccess}
        initialGroupAccessName={groupAccessName}
      />
    </div>
  );
}
